/* LUGAZI: DROPPING SOON (24 Oct 2026, Leandro) - nothing can be bought yet and no prices show.
   - product pages: the price is hidden and Add to bag gives way to a DROPPING SOON button; a tap on it opens the waiting list
   - the shop: no prices and no SOLD OUT, a small DROPPING SOON under each piece
   - checkout buttons are hidden everywhere, and nothing can be put in the bag from the site
   The hiding itself is a style in layout/theme.liquid (so no price ever flashes). To undo: take out that style and this script. */
(function () {
  if (window.__lgzDrop) return; window.__lgzDrop = 1;

  /* the waiting list (the same card the sold-out button used to open) */
  function openList(handle) {
    var l = document.querySelector('.lwl'); if (!l) { location.href = '/#waitlist'; return; }
    var t = l.querySelector('.lwl-tags'); if (t) t.value = 'waitlist,dropping-soon' + (handle ? ',' + handle : '');
    l.dataset.mode = 'modal'; l.hidden = false; l.dataset.lgzSold = '1';
    requestAnimationFrame(function () { requestAnimationFrame(function () { l.classList.add('is-open'); }); });
    document.body.classList.add('lwl-modal-open');
  }

  /* nothing goes into the bag */
  document.addEventListener('submit', function (e) {
    var f = e.target; if (f && f.action && /\/cart\/add/.test(f.action)) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);
  var F = window.fetch;
  if (F) window.fetch = function (u, o) {
    var url = typeof u === 'string' ? u : (u && u.url) || '', m = (o && o.method) || (u && u.method) || 'GET';
    if (/\/cart\/add/.test(url) && /post/i.test(m)) return Promise.resolve(new Response(JSON.stringify({ status: 422, message: 'Dropping soon', description: 'Dropping soon' }), { status: 422, headers: { 'Content-Type': 'application/json' } }));
    return F.apply(this, arguments);
  };

  function product() {
    var add = document.querySelector('.lzp-add'); if (!add || document.querySelector('.lgz-drop-btn')) return;
    var b = document.createElement('button'); b.type = 'button'; b.className = 'lgz-drop-btn'; b.textContent = 'DROPPING SOON';
    b.setAttribute('aria-label', 'Dropping soon - join the waiting list');
    b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); openList(location.pathname.split('/').pop()); });
    add.parentNode.insertBefore(b, add);
  }
  function shop() {
    [].forEach.call(document.querySelectorAll('.lzs-item .lzs-card'), function (c) {
      if (c.querySelector('.lgz-drop-tag')) return;
      var s = document.createElement('span'); s.className = 'lgz-drop-tag'; s.textContent = 'DROPPING SOON'; c.appendChild(s);
    });
  }
  function go() { try { product(); shop(); } catch (e) {} }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
  var n = 0, iv = setInterval(function () { go(); if (++n > 25) clearInterval(iv); }, 800);
})();
